const SESSION_EXPIRES_IN_SECONDS = 30 * 24 * 60 * 60; // 30days
const COOKIE_REMEMBER_ME = 'fc-v2-auth-remember-me';

// TODO: util 쪽에 있는 함수들과의 관계 정리...
const isValidName = (str) =>
  /(^[가-힣]{2,5}$)|(^([a-z,A-Z]|[^\s,-][\s,-]){3,19}([^\s,-]|[a-z,A-Z])+$)/.test(str.trim());
const isValidPhone = (str) => /^01[\d{1}]-?\d{3,4}-?\d{4}$/.test(str.trim());
const isValidEmail = (str) =>
  /^[0-9a-zA-Z]([-_.+]?[0-9a-zA-Z_-])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*[.](([a-zA-Z]{1,2}$)|(([^cC][a-zA-Z][a-zA-Z])|([a-zA-Z][^oO][a-zA-Z])|([a-zA-Z][a-zA-Z][^nN])$))/i.test(
    str.trim()
  );
// todo: password 벨리데이션 (영문/숫자/특문 중 2가지 조합 + 8 자리 이상)
const isValidPassword = (str) => str.length > 7;
const isValidRedeem = (str) => str.length > 2;
const isValidEmailSecret = (str) => /^\d{6}$/.test(str);
const isValidPhoneSecret = (str) => /^\d{4}$/.test(str);

// ref. https://fastcampus.atlassian.net/browse/V2-2719
const EMAIL_SECRET_TTL_IN_MIN = 10;
const EMAIL_SECRET_TTL_IN_SEC = EMAIL_SECRET_TTL_IN_MIN * 60;
const PHONE_SECRET_TTL_IN_MIN = 3;
const PHONE_SECRET_TTL_IN_SEC = PHONE_SECRET_TTL_IN_MIN * 60;
const PASSWORD_RESET_CODE_TTL_IN_MIN = 10;
const PASSWORD_RESET_CODE_TTL_IN_SEC = PASSWORD_RESET_CODE_TTL_IN_MIN * 60;

module.exports = {
  SESSION_EXPIRES_IN_SECONDS,
  COOKIE_REMEMBER_ME,
  isValidName,
  isValidPhone,
  isValidEmail,
  isValidPassword,
  isValidRedeem,
  isValidEmailSecret,
  isValidPhoneSecret,
  EMAIL_SECRET_TTL_IN_MIN,
  EMAIL_SECRET_TTL_IN_SEC,
  PHONE_SECRET_TTL_IN_MIN,
  PHONE_SECRET_TTL_IN_SEC,
  PASSWORD_RESET_CODE_TTL_IN_MIN,
  PASSWORD_RESET_CODE_TTL_IN_SEC,
};
